import Cookies from 'universal-cookie';
import { COOKIE_NAMES } from 'lib/enums/cookies';

const getIsIframeLoaded = (): boolean => {
  const cookies = new Cookies();

  return !!cookies.get(COOKIE_NAMES.IFRAME_CONTENT_LOADED);
};

export default getIsIframeLoaded;
